import { render, staticRenderFns } from "./OrderModifyDeposit.vue?vue&type=template&id=94a2d5fa&scoped=true"
import script from "./OrderModifyDeposit.vue?vue&type=script&lang=js"
export * from "./OrderModifyDeposit.vue?vue&type=script&lang=js"
import style0 from "./OrderModifyDeposit.vue?vue&type=style&index=0&id=94a2d5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a2d5fa",
  null
  
)

export default component.exports